import { render, staticRenderFns } from "./adoptionCenter.vue?vue&type=template&id=1283befc&scoped=true"
import script from "./adoptionCenter.vue?vue&type=script&lang=js"
export * from "./adoptionCenter.vue?vue&type=script&lang=js"
import style0 from "./adoptionCenter.vue?vue&type=style&index=0&id=1283befc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283befc",
  null
  
)

export default component.exports